import { openSettingsDialog, closeSettingsDialog, toggleSettingsDialog } from '@core/state/actions/settingsDialogActions';
import { selectIsSettingsDialogOpen } from '@core/state/selectors';
import { useAppDispatch, useAppSelector } from '@store';
import { useCallback } from 'react';

/**
 * Custom hook for managing the settings dialog
 * @returns Object with settings dialog state and methods
 */
export function useSettingsDialog() {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectIsSettingsDialogOpen);

  // Open the settings dialog
  const openDialog = useCallback(() => {
    dispatch(openSettingsDialog());
  }, [dispatch]);

  // Close the settings dialog
  const closeDialog = useCallback(() => {
    dispatch(closeSettingsDialog());
  }, [dispatch]);

  // Toggle the settings dialog
  const toggleDialog = useCallback(() => {
    dispatch(toggleSettingsDialog());
  }, [dispatch]);

  return {
    isOpen,
    openDialog,
    closeDialog,
    toggleDialog,
  };
}
